import { IconButton, Tooltip } from '@mui/material';
import { DoubleCheckIcon } from '@schooly/style';
import { FC } from 'react';

interface ConductVisibilityButtonProps {
  onClick?: () => void;
  tooltipTitle?: React.ReactNode;
  selected?: boolean;
  width?: number;
  nowrap?: boolean;
}
export const ConductVisibilityButton: FC<ConductVisibilityButtonProps> = ({
  onClick,
  tooltipTitle,
  selected,
  width,
  nowrap,
}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        inverse={selected}
        className="icon-ConductVisibility"
        sx={{
          color: selected ? 'primary.main' : 'text.secondary',
        }}
        onClick={onClick}
      >
        <DoubleCheckIcon />
      </IconButton>
    </Tooltip>
  );
};
